import { useMemo } from 'react'

export const useMonolithUrl = () => {
  return useMemo(() => {
    const currentUrl = window.location.hostname
    if (currentUrl.includes('localhost') || currentUrl.includes('dev')) {
      return 'https://dev01.icebergfinance.ca'
    }
    if (currentUrl.includes('int') || currentUrl.includes('uat')) {
      return 'https://tests.icebergfinance.ca'
    }
    return 'https://secure.icebergfinance.ca'
  }, [])
}
